//import { gaWrapper } from 'helpers/analytics';
import { getSiteDomain } from 'utils/common';
// import { adBlockerStatus } from 'utils/common';

const adBlockPromise = new Promise(resolve => {
  //   const callbacks = [];

  function addListener(event, fn) {
    if (document.addEventListener) {
      document.addEventListener(event, fn, false);
    } else if (document.attachEvent) {
      document.attachEvent(event, fn);
    }
  }

  function removeListener(event, fn) {
    if (document.removeEventListener) {
      document.removeEventListener(event, fn);
    } else if (document.removeEvent) {
      document.removeEvent(event, fn);
    }
  }

  const detected = () => {
    resolve(true);
    removeListener('scroll', detected); //Prevent multiple executions
  };

  const notDetected = () => {
    resolve(false);
  };

  async function initBlock() {
    window.adBlocked = false; // make it false
    let adBlockedtext = '';
    try {
      await fetch(`${getSiteDomain()}/toiads_prebid_checker/adset/ve-1.cms`)
        .then(() => {})
        .catch(() => {
          window.adBlocked = true;
        });
    } catch (err) {
      window.adBlocked = true;
    }

    if (
      window.adBlocked &&
      document.addEventListener.toString().indexOf('[native code]') === -1
    ) {
      detected();
      return;
    }
    if (typeof window !== 'undefined' && !window.adBlockerEventSentOnce) {
      window.adBlockerEventSentOnce = true;
      if (!window.adBlocked) {
        adBlockedtext = 'No';
        // gaWrapper('send', 'event', 'adBlocker', 'No', window.location.href, {
        //   nonInteraction: true,
        // });
      } else {
        adBlockedtext = 'Yes';
        // gaWrapper('send', 'event', 'adBlocker', 'Yes', window.location.href, {
        //   nonInteraction: true,
        // });
      }

      const dataLayer = window.dataLayer || [];
      dataLayer.push({
        event: 'adBlocker',
        is_ad_blocked: adBlockedtext,
      });
    }

    if (window.adBlocked && !window.canRun) {
      addListener('scroll', detected);
    } else {
      notDetected();
    }
  }

  function fromFB() {
    if (typeof document !== 'undefined') {
      return null;
    }
    try {
      return (
        (document.referrer !== '' &&
          document.referrer.indexOf('facebook.com') > -1) ||
        (window.location.href &&
          window.location.href.indexOf('utm_source=facebook') > -1)
      );
    } catch (err) {
      console.log(err);
    }
    return null;
  }

  //Blocker will not be shown if referer is from facebook
  if (!fromFB()) {
    setTimeout(initBlock, 2000);
    // Add this because no image object at node side
    // window.canRun = true;
    // initBlock();
  }
});
export default adBlockPromise;
